class ProductMedia extends window.BAO.CustomElement {
  connectedCallback () {
    super.connectedCallback()
    this.setupListeners()

    this.images = this.querySelectorAll('[data-variant-image]')
    this.availableIds = Array.from(this.images, image =>
      image.getAttribute('data-variant-image')
    )
  }

  setupListeners () {
    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.VARIANT_CHANGE,
      e => {
        if (!e.detail.data.id) return
        this.updateImage(e.detail.data.id)
      }
    )
  }

  updateImage (id) {
    id = id?.toString()
    if (!this.availableIds.includes(id)) return

    this.images.forEach(image => {
      if (image.getAttribute('data-variant-image') === id) {
        image.setAttribute('data-active', true)
      } else {
        image.removeAttribute('data-active')
      }
    })
  }
}

if (!customElements.get('product-media')) {
  customElements.define('product-media', ProductMedia)
}
